import { AnimationTriggerMetadata, style, transition, trigger, animate } from '@angular/animations';

export const openCloseAnimation: AnimationTriggerMetadata = trigger('openCloseAnimation', [
    transition(':enter', [
        style({
            height: '0px',
            opacity: '0'
        }),
        animate(
            '0.5s ease-in-out',
            style({
                height: '200px',
                opacity: '1'
            })
        )
    ]),
    transition(':leave', [
        style({
            height: '200px',
            opacity: '1'
        }),
        animate(
            '0.5s ease-in-out',
            style({
                height: '0px',
                opacity: '0'
            })
        )
    ])
]);
